jQuery(function($) {
// 商品詳細アコーディオン
$('.js--toggle').on('click', function () {
  $(this).toggleClass('is-open');
  $(this).next(".accordion-text").find(".overview").slideToggle(300);
});

$('.js--toggle2').on('click', function () {
  $(this).toggleClass('is-open');
  $(this).next(".accordion-text").find(".productdetail").slideToggle(300);
});


// 商品詳細shareボタンモーダル
  // 変数に要素を入れる
    open = $('.sharebutton'),
    close = $('.modal-close'),
    container = $('.modal-container');

  //開くボタンをクリックしたらモーダルを表示する
  open.on('click',function(){ 
    container.addClass('active');
    return false;
  });

  //閉じるボタンをクリックしたらモーダルを閉じる
  close.on('click',function(){  
    container.removeClass('active');
  });

  //モーダルの外側をクリックしたらモーダルを閉じる
  $(document).on('click',function(e) {
    if(!$(e.target).closest('.modal-body').length) {
      container.removeClass('active');
    }
  });
});